export default function ordinalTransform(input) {
  return input
    .replace(/a/gi, "ᵃ")
    .replace(/b/gi, "ᵇ")
    .replace(/c/gi, "ᶜ")
    .replace(/d/gi, "ᵈ")
    .replace(/e/gi, "ᵉ")
    .replace(/f/gi, "ᶠ")
    .replace(/g/gi, "ᵍ")
    .replace(/h/gi, "ʰ")
    .replace(/i/gi, "ᶤ")
    .replace(/j/gi, "ʲ")
    .replace(/k/gi, "ᵏ")
    .replace(/l/gi, "ˡ")
    .replace(/m/gi, "ᵐ")
    .replace(/n/gi, "ᶰ")
    .replace(/o/gi, "ᵒ")
    .replace(/p/gi, "ᵖ")
    .replace(/q/gi, "ˁ")
    .replace(/r/gi, "ʳ")
    .replace(/s/gi, "ˢ")
    .replace(/t/gi, "ᵗ")
    .replace(/u/gi, "ᵘ")
    .replace(/v/gi, "ᵛ")
    .replace(/x/gi, "ˣ")
    .replace(/w/gi, "ʷ")
    .replace(/y/gi, "ʸ")
    .replace(/z/gi, "ᶻ")
    .replace(/ /gi, "ㅤ")
    .replace(/1/gi, "¹")
    .replace(/2/gi, "²")
    .replace(/3/gi, "³");
}
